import readingPaneStore from '../store/Store';
import { mutatorAction } from 'satcheljs';

const setShouldShowMobileUpsellEmptyStateMutator: (
    shouldShowMobileUpsellEmptyState: boolean
) => void = mutatorAction(
    'setShouldShowMobileUpsellEmptyState',
    (shouldShowMobileUpsellEmptyState: boolean): void => {
        readingPaneStore().shouldShowMobileUpsellEmptyState = shouldShowMobileUpsellEmptyState;
    }
);
export default setShouldShowMobileUpsellEmptyStateMutator;
